import { ORIGIN } from "@data/GlobalData.js";
import { OnlyAlphaNumeric } from "@genericComponents/Common.js";
import { GetConfig } from "@genericComponents/SFW.js";
export const Folders = {
  ContentVideo: "ContentVideo",
  ContentPicture: "ContentPicture",
  ContentSound: "ContentSound",
  SiteMapImage: "SiteMapImage",
  ContentDocument: "ContentDocument",
  SiteMap: "SiteMap",
  LLMS: "LLMS",
  DefaultInitData: `DefaultInitData-${OnlyAlphaNumeric(ORIGIN, true)}`,
  ProfilePic: "ProfilePic",
  ItemPic: "ItemPic",
  ResellerPackageItemPic: "ResellerPackageItemPic",
  BannerPic: "BannerPic",
  DynamicOptionPic: "DynamicOptionPic",
  POGOPic: "POGOPic",
  ProductPic: "ProductPic",
  ClientProfileFiles: "ClientProfileFiles",
  EducationFiles: "EducationFiles",
  JobPostFiles: "JobPostFiles",
  OtherCredentialFiles: "OtherCredentialFiles",
  MarketingScripts: "MarketingScripts",
  PortfolioFiles: "PortfolioFiles",
  JobProfileFiles: "JobProfileFiles",
  ClientLogoPic: "ClientLogoPic",
  ServicePic: "ServicePic",
};
export const GetFileName = (userGUID, fileName) => {
  return [
    userGUID,
    "-",
    Math.floor(Date.now() / 1000),
    ".",
    fileName.substring(fileName.lastIndexOf(".") + 1),
  ].join("");
};
export const GetFile = (
  folder,
  filename,
  defaultPic = null,
  noLengthLimit = false,
) => {
  if (!filename) {
    return defaultPic || filename;
  }
  if (noLengthLimit || filename.length < 100) {
    if (filename.includes(GetConfig("FileUrl"))) {
      return filename;
    }
    return [GetConfig("FileUrl"), folder, "/", filename].join("");
  } else {
    return filename;
  }
};
